import { useState } from 'react';
import { ShapefileDetailView } from './ShapefileDetailView';
import type { Shapefile } from '../../types/shapefile';

interface ShapefileRouterProps {
  renderList: (onViewDetails: (shapefile: Shapefile) => void) => React.ReactNode;
  onDownload: (shapefile: Shapefile) => void;
  loading?: boolean;
}

export function ShapefileRouter({ 
  renderList, 
  onDownload, 
  loading = false 
}: ShapefileRouterProps) {
  const [currentView, setCurrentView] = useState<'list' | 'detail'>('list');
  const [selectedShapefile, setSelectedShapefile] = useState<Shapefile | null>(null);

  const handleViewDetails = (shapefile: Shapefile) => {
    setSelectedShapefile(shapefile);
    setCurrentView('detail');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedShapefile(null);
  };

  if (currentView === 'detail' && selectedShapefile) {
    return (
      <ShapefileDetailView
        shapefile={selectedShapefile}
        onBack={handleBackToList}
        onDownload={onDownload}
        loading={loading}
      />
    );
  }

  return <>{renderList(handleViewDetails)}</>;
} 